import type { Bestellung } from '@/types/detail';

export type AdressTeile = {
  strasse: string | null;
  plz: string | null;
  ort: string | null;
};

function ersteGefuellte(...werte: (string | null | undefined)[]): string | null {
  for (const w of werte) {
    const t = (w ?? '').trim();
    if (t !== '') return t;
  }
  return null;
}

/**
 * Die tatsaechlich zustellwirksame Adresse: die Lieferadresse der Bestellung
 * ueberschreibt die Stammadresse des Kunden, leere Strings zaehlen wie NULL.
 * Muss zur Logik in api/sendungen/create.php passen.
 */
export function effektiveLieferadresse(b: Bestellung): AdressTeile {
  const l = b.lieferadresse;
  const s = b.kunde.stamm_adresse;
  return {
    strasse: ersteGefuellte(l.strasse, s.strasse),
    plz: ersteGefuellte(l.plz, s.plz),
    ort: ersteGefuellte(l.ort, s.ort)
  };
}

/** Pflichtfelder fuer Zustell-Sendungen (B22). Abholung braucht nichts davon. */
export function fehlendeVersandfelder(a: AdressTeile): string[] {
  const fehlt: string[] = [];
  if (a.strasse === null) fehlt.push('Straße');
  if (a.plz === null) fehlt.push('PLZ');
  if (a.ort === null) fehlt.push('Ort');
  return fehlt;
}

function istDeutschland(land: string): boolean {
  const t = land.trim();
  return t === '' || /^(de|deutschland|germany)$/i.test(t);
}

/**
 * Weiche Formatwarnung fuer die PLZ (B28) — blockiert nichts, macht nur
 * auf einen wahrscheinlichen Tippfehler aufmerksam.
 */
export function plzWarnung(plz: string, land: string): string | null {
  const t = plz.trim();
  if (t === '') return null;
  if (istDeutschland(land) && !/^\d{5}$/.test(t)) {
    return 'PLZ in Deutschland: genau 5 Ziffern.';
  }
  return null;
}
